import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {TermsOfUseService} from '../../services/terms-of-use.service';
import {TermsOfUseResponse} from '../../models/terms-of-use-response.model';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TermsOfUseComponent implements OnInit {

  checkboxFlag = false;
  disableCheckbox = false;
  currentTermsOfUseResponse: TermsOfUseResponse = null;

  @Output()
  termsOfUseErrorEvent = new EventEmitter<boolean>(false);

  constructor(private termsOfUseService: TermsOfUseService) {}

  ngOnInit(): void {
    this.termsOfUseService.getTermsOfUse().subscribe(resp => {
      this.currentTermsOfUseResponse = resp[0]

    },
    error => {
        this.termsOfUseErrorEvent.emit(true);
        this.disableCheckbox = true;
    });
  }

  checkValue(value: boolean): void {
     console.log(value);
     this.checkboxFlag = value;
  }
}
